import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FilesService } from "src/app/services/shared/files/files.service";
import { NotificationService } from 'src/app/services/shared/notification/notification.service';

@Component({
  selector: 'app-file-upload-and-preview',
  templateUrl: './file-upload-and-preview.component.html',
  styleUrls: ['./file-upload-and-preview.component.scss'],
  providers: [FilesService]
})
export class FileUploadAndPreviewComponent implements OnInit {

  constructor(
    private file_service: FilesService,
    private notification_srv: NotificationService
  ) { }

  ngOnInit(): void {
    console.log('here')
    let drop_zone = document.getElementById('drop-zone');

    ['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
      drop_zone.addEventListener(eventName, (e) => {
        e.preventDefault()
        e.stopPropagation()
      }, false)
    })
    drop_zone.addEventListener('drop', this.fileInputDropped.bind(this), false);
  }
  active;
  @Input() public width = 400;
  @Input() public height = 400;
  @Input() public label = "Digital Signature";
  @Input() public placeholder = "Drop a file here or click to upload";

  @Input() type;
  @Input() manual_upload = 0;
  @Input() supported_files = ['jpeg', 'png', 'jpg'];
  @Input() value;
  @Input() id;
  @Input() style;
  @Input() class;
  @Input() hint;
  @Input() control_type;
  @Input() required;
  @Input() error_msg;
  @Input() controlName;
  @Input() ngModel;
  @Input() verified_status;
  @Input() notes;
  @Input() reason;
  @Input() verification_required;
  @Input() hide_label;

  @Output() returnFiles = new EventEmitter();
  @Output() uploadStatus = new EventEmitter();
  @Input() label_block;
  @Input() context_menu_listner;
  @Input() on_change_listner;
  @Input() html_decode;
  @Input() disabled;
  @Input() resetCallbackRef;
  @Input() form_group;
  @Input() form_control;
  @Input() server_filename = "a_fn";
  @Input() server_cdnpath = "a_url";
  @Input() save_filename = "fileName";
  @Input() save_cdnpath = "cdnPath";
  uploadingStatus = false;
  selected_files = []
  result = [];
  storage_url = 'https://storage.googleapis.com/ezeone/icanrefer/';


  clearSign() {

    if (this.resetCallbackRef) {
      this.resetCallbackRef();
    }
    else {
      this.form_group.get(this.form_control).reset();
    }

  }

  fileInputDropped(ev) {
    if (!this.disabled) {
      this.fileInputChanged(ev.dataTransfer.files);
    }
  }

  fileInputChanged(files) {
    if (!this.disabled) {
      let valid_files = [];
      if (!this.uploadingStatus) {
        this.file_service.convertFilesToBase64(files).subscribe(res => {
          let all_files = res as any;

          all_files.forEach(f => {
            if (this.supported_files.findIndex(data => (data).toLowerCase() == (f.extension).toLowerCase()) > -1) {
              if (f.size < 2000000) {
                valid_files.push(f);
              }
              else {
                this.notification_srv.error('File size must be less than 2MB', 'Close', 5000);
              }
            }
            else {
              this.notification_srv.error(f.fileName + ' ' + 'not supported', 'Close', 5000);
            }
          })
          this.selected_files = valid_files || [];
          if (!this.manual_upload) {
            if (this.selected_files && this.selected_files.length) {

              this.result = this.selected_files || [];
              let f = this.file_service.makeFormDataFile(this.result[0]);
              let form_data = new FormData();
              form_data.append('attachment', f, f.name)
              this.notification_srv.success('FILES.uploading_attachments', 'Close', 3000);
              this.uploadingStatus = true;
              this.uploadStatus.emit(false);
              this.file_service.uploadAttachment(form_data).subscribe(res => {
                // let res = {
                //   data: {
                //     a_fn: "IMG_20210617_172535.jpg",
                //     a_url: "92955ba7-d03a-4199-ba12-d318e1bf3caa.jpg"
                //   },
                //   "message": "Uploaded!!!"
                // }


                let attach = {}
                if (res && res['data']) {
                  this.notification_srv.success(res['message'], 'Close', 3000);
                  attach[this.save_filename] = res['data'][this.server_filename];
                  attach[this.save_cdnpath] = res['data'][this.server_cdnpath];
                  // attach['width'] = this.result_dimentions[0].width
                  // attach['height'] = this.result_dimentions[0].height
                  this.result = [attach]
                  try {

                    this.form_group.get([this.form_control]).patchValue(this.result);
                    this.uploadStatus.emit(true)
                    this.uploadingStatus = false;
                    this.returnFiles.emit({
                      result: [attach],
                    })
                  }
                  catch (err) {

                  }
                }
                else {
                  this.notification_srv.error(res && res['message'], 'Close', 3000);
                  this.returnFiles.emit({
                    result: this.result
                  })
                }

              })



            }
          }
          else {
            this.result = this.selected_files;
            if (this.selected_files && this.selected_files.length) {
              this.returnFiles.emit({ result: this.selected_files })
            }
          }


        })
      }
      else {
        this.notification_srv.error('ERROR.please_wait_while_attachments_being_uploaded', 'Close', 5000)
      }
    }
  }
}
